export default [
  {
    path: '/classcard/classrank/message',
    name: 'PageClassrankMessage',
    component: () =>
      import(
        /* webpackChunkName: "message" */ '../pages/message/PageClassrankMessage'
      ),
    meta: { modular: 22, title: '留言', info: '留言——首页' }
  }
]
